import { useTranslation } from "react-i18next";

const UploadPhotos: React.FunctionComponent<{ OnUploadImages: any }> = (props) => {

    const { t } = useTranslation();

    function getRandomSixDigitNumber(): number {
        return Math.floor(100000 + Math.random() * 900000);
    }

    const processFiles = async (files: any[]) => {
        const oversized: any[] = [];
        const validFiles: any[] = [];
        let hasOversized = false;

        for (let file of files) {
            if (file.size > 10 * 1024 * 1024) {
                hasOversized = true;
                oversized.push(file);
            } else {
                validFiles.push(file);
            }
        }

        setTimeout(() => {
            handleValidFileProcessing(validFiles,hasOversized);
        }, 0);
    };

    const handleValidFileProcessing = async (files: any[],value :boolean) => {
        const processedImages: any[] = [];

        for (let file of files) {
            const reader = new FileReader();
            const result = await new Promise<string>((resolve) => {
                reader.onload = () => resolve(reader.result as string);
                reader.readAsDataURL(file);
            });
            const ext = file.type.split('/')[1];
            processedImages.push({ id: getRandomSixDigitNumber(), src: result, ext ,toAnalyze :false});
        }
        props.OnUploadImages(processedImages, value);
    };

    const HandleChangeUpload = async (event: any) => {
        const files = Array.from(event.target.files);
        await processFiles(files);
    };


    return (
        <div className="upload-photos">
            <label className="form_container padd-30 box-g " >
            <p className="mt-3">{t("startUploading.startByUploading")}</p>
                <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_1121_4751)">
                        <path d="M8.33334 35.417V39.5837C8.33334 40.6887 8.77233 41.7485 9.55373 42.5299C10.3351 43.3113 11.3949 43.7503 12.5 43.7503H37.5C38.6051 43.7503 39.6649 43.3113 40.4463 42.5299C41.2277 41.7485 41.6667 40.6887 41.6667 39.5837V35.417" stroke="#6366F1" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M8.33334 35.417V39.5837C8.33334 40.6887 8.77233 41.7485 9.55373 42.5299C10.3351 43.3113 11.3949 43.7503 12.5 43.7503H37.5C38.6051 43.7503 39.6649 43.3113 40.4463 42.5299C41.2277 41.7485 41.6667 40.6887 41.6667 39.5837V35.417" stroke="black" strokeOpacity="0.2" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M14.5833 18.7497L25 8.33301L35.4167 18.7497" stroke="#6366F1" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M14.5833 18.7497L25 8.33301L35.4167 18.7497" stroke="black" strokeOpacity="0.2" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M25 8.33301V33.333" stroke="#6366F1" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M25 8.33301V33.333" stroke="black" strokeOpacity="0.2" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
                    </g>
                    <defs>
                        <clipPath id="clip0_1121_4751">
                            <rect width="50" height="50" fill="white" />
                        </clipPath>
                    </defs>
                </svg>
                <input className="form__file" accept="image/jpeg, image/jpg, image/png, image/webp" type="file" multiple onChange={HandleChangeUpload} />
            </label>
        </div>
    )
}

export default UploadPhotos;